<app-breadcrumb [master]="'Administracja'" [parentName]="'Regionalni'" [name]="'Lista'"></app-breadcrumb>
<div class="regional-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="regional-list-filters">
    <mat-form-field class="regional-list-filter">
      <mat-label>Imie</mat-label>
      <input matInput placeholder="Jan" name="firstName" [(ngModel)]="initialFilters.firstName">
    </mat-form-field>

    <mat-form-field class="regional-list-filter">
      <mat-label>Nazwisko</mat-label>
      <input matInput placeholder="Kowalski" name="lastName" [(ngModel)]="initialFilters.lastName">
    </mat-form-field>

    <mat-form-field class="regional-list-filter">
    <mat-label>Aktywny</mat-label>
    <mat-select [(ngModel)]="initialFilters.deleted" name="deleted">
      <mat-option [value]="null">Wszyscy</mat-option>
      <mat-option [value]="0">Tak</mat-option>
      <mat-option [value]="1">Nie</mat-option>
    </mat-select>
    </mat-form-field>

  </form>

  <div class="regional-list-buttons">
    <div class="pull-left">
    <a  [routerLink]="['/uzytkownicy/regionalni/dodaj']">
      <button  [disabled]="!(userPermissions | async).user.write"
               mat-raised-button class="report-button"><mat-icon>add</mat-icon> Dodaj</button></a>
  </div>
    <div class="pull-right">
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef> Imię i nazwisko </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/uzytkownicy/regionalni/szczegoly', element.uuid]">
        {{element.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef> Imie </th>
      <td mat-cell *matCellDef="let element">
        {{element.firstName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef> Nazwisko </th>
      <td mat-cell *matCellDef="let element">
        {{element.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element">
        {{element.email }}
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
      <td mat-cell *matCellDef="let element">
        {{ element.accountUser?.phone  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="deleted">
      <th mat-header-cell *matHeaderCellDef> Aktywny </th>
      <td mat-cell *matCellDef="let element">
        {{!element.deleted ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
